enum ErrorType {
	Network = "Network",
	Default = "Default",
	Git = "Git",
	Silent = "Silent",
	Parse = "Parse",
	Frontmatter = "Frontmatter",
	NetworkApi = "NetworkApi",
	TokenValidation = "TokenValidation",
	CliUser = "CliUser",
}

export default ErrorType;
